import { state } from "@src/state";
export const selectIsMixerOpen = () => state.meeting.studio.mixer.isPanelOpen;
